import { Injectable, OnDestroy } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Meta } from "@angular/platform-browser";
import { ProgramService } from "../../customer/services/program.service";

@Injectable()
export class BlockFromGoogleGuard implements OnDestroy {
  constructor(
    private programService: ProgramService,
    private router: Router,
    private meta: Meta,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const programId = await route.params["programId"];
    let isBlockedFromGoogle = false;

    if (!!programId && !isNaN(+programId)) {
      isBlockedFromGoogle = await this.programService
        .getIsProgramBlockedFromGoogle(programId)
        .toPromise();
    }

    if (isBlockedFromGoogle) {
      this.addMetaTag();
    }
  }

  addMetaTag() {
    this.meta.addTag({ name: "googlebot", content: "noindex" });
    this.meta.addTag({ name: "robots", content: "noindex" });
  }

  ngOnDestroy(): void {
    this.meta.removeTag("name:'googlebot'");
    this.meta.removeTag("name:'robots'");
  }
}
